import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTaskListCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n            .a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "task-list-check" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M16.313,11.26l-5.592,5.592a.818.818,0,0,1-1.158,0L7.688,14.976"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15.75,4.51H19.5A1.5,1.5,0,0,1,21,6.01V21.76a1.5,1.5,0,0,1-1.5,1.5H4.5A1.5,1.5,0,0,1,3,21.76V6.01a1.5,1.5,0,0,1,1.5-1.5H8.25a3.75,3.75,0,0,1,7.5,0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12.057,3.765a.375.375,0,1,1-.428.313.375.375,0,0,1,.428-.313"
		})
	]
});
export default SvgTaskListCheck;
